import { render, staticRenderFns } from "./ItemInfoTable.vue?vue&type=template&id=a0a428a4&scoped=true&"
import script from "./ItemInfoTable.vue?vue&type=script&lang=js&"
export * from "./ItemInfoTable.vue?vue&type=script&lang=js&"
import style0 from "./ItemInfoTable.vue?vue&type=style&index=0&id=a0a428a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a428a4",
  null
  
)

export default component.exports